var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-breadcrumbs',_vm._b({staticClass:"brand-serie-product-nav px-0 py-0",attrs:{"items":_vm.items,"large":"","divider":"/"}},'v-breadcrumbs',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }